// extracted by mini-css-extract-plugin
export default {"section_item_title":"style_section_item_title__gnaSp"};